import moment from 'moment';
import Top    from './TopPart';
import Bottom from './BottomPart';
import escapeTwig from '../escapeTwig';
import inlineQuoteStyles from '../inlineQuoteStyles';
import replyHeader from '../replyHeader';


moment.locale('de');


const baseURL = window.location.origin;

const emailParse = function (email, locale) {
    if (email) {
        let htmlText = replyHeader(email, locale);

        if (email.textHtml) {
            let content = new DOMParser().parseFromString(email.textHtml, 'text/html');
            //     Removing base because it interferes with our js code   <base href="some_url">
            // TODO - this will break the email links - find a better solution
            htmlText += '<div dir="ltr"><br></div>' + inlineQuoteStyles(content);

            // Fix relative paths for signature images
            htmlText = htmlText.replace(/\.\.\/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');
            htmlText = htmlText.replace(/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');

            if(!email.attachments) {
                email.attachments = [];
            }

            for (const attachment of email.attachments) {
                if ((attachment.disposition === 'inline' || !attachment.disposition) && attachment.type === 'image') {
                    htmlText = htmlText.replace(
                        new RegExp('cid:' + attachment.id, 'g'),
                        '/files/' + attachment.filePath
                    );
                }
            }


        } else {
            htmlText += '<div dir="ltr"><br></div>' + email.textPlain;
        }

        return escapeTwig(htmlText);

    } else {
        return '';
    }
};


export default function (body = '', phone = '', email = null, locale = 'de_DE') {
    return Top + `
    <div class=WordSection1>




<!-- bodyContentStart --><p class=MsoNormal><a name="_MailAutoSig"><span style='mso-fareast-language:DE'>${body}</span></p><!-- bodyContentEnd -->


</div>
   ` +

        emailParse(email, locale) +

        Bottom;
}
